/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Live_ActionInputs */

const en_us2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the workout`)
};

const pt_br2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao treino`)
};

const es_419_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al entrenamiento`)
};

const pt_pt2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao treino`)
};

const fr_fr2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la séance`)
};

const de_de2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Training`)
};

const it_it2_workout_quick_live_action = /** @type {(inputs: Workout_Quick_Live_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna all'allenamento`)
};

/**
* | output |
* | --- |
* | "Back to the workout" |
*
* @param {Workout_Quick_Live_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_live_action = /** @type {((inputs?: Workout_Quick_Live_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Live_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_live_action(inputs)
	if (locale === "es-419") return es_419_workout_quick_live_action(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_live_action(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_live_action(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_live_action(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_live_action(inputs)
	return en_us2_workout_quick_live_action(inputs)
});
export { workout_quick_live_action as "workout-quick.live_action" }